module.exports = __webpack_public_path__ + "static/fonts/OswaldRegular.f57b0d8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/OswaldRegular.ttf
// module id = 1045
// module chunks = 111